/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/User/UserB2B.Forms',[], function () {
    'use strict';

    var forms = {
        'AddSubUser': {
            Fields: [
                {
                    'Name': 'First Name',
                    'Field': '#register_first_name',
                    'Param': 'firstName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Last Name',
                    'Field': '#register_last_name',
                    'Param': 'lastName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Email',
                    'Field': '#register_email',
                    'Param': 'email',
                    'Type': 'Text',
                    'Validators': [
                        {
                            'Type': 'Email'
                        }]
                },
                {
                    'Name': 'Confirm Email',
                    'Field': '#register_email2',
                    'Param': 'emailConfirm',
                    'Type': 'Text',
                    'Validators': [
                        {
                             'Type': 'Email'
                        },
                        {
                            'Type': 'ConfirmField',
                            'OriginField': '#register_email',
                            'ErrorMsg': 'Email does not match the confirm email.'
                        }]
                },

            ],
            Validate: true
        }
    };

    return forms;
});
